module.exports = __webpack_public_path__ + "img/27.635307f1.png";